<template>
  <div v-if="personData" @keyup.enter="login" class="mt-6 p-lg-6 p-3">
    <h3 class="text-secondary font-weight-light text-center">{{ $t("common.welcome_screen.welcome_back") }}</h3>
    <input
      :value="personData.email"
      @input="updateValues('email')"
      :placeholder="$t('common.welcome_screen.enter_email')"
      ref="emailInput"
      type="email"
      class="form-control"
      disabled>
    <input
      :value="personData.password"
      @input="updateValues('password')"
      :placeholder="$t('common.welcome_screen.enter_password')"
      ref="passwordInput"
      type="password"
      autocomplete="current-password"
      class="form-control mt-2"
      autofocus>

    <button
      @click="emitStep('restore')"
      class="btn btn-sm btn-link mt-2 text-muted float-left"
    >
      {{ $t("common.welcome_screen.forgot_password") }}
    </button>

    <button
      @click="login"
      class="btn btn-sm btn-primary mt-2 mt-2 float-right">
      {{ $t("common.welcome_screen.log_in") }}
      <i class="fe fe-arrow-right"></i>
    </button>
    <button
      @click="emitStep('auth')"
      class="btn text-muted btn-sm btn-link  mt-2 float-right mr-2">
      <i class="fe fe-arrow-left"></i>
      {{ $t("common.welcome_screen.back") }}
    </button>

    <div v-if="showInvite" class="dash-section p-3 mt-6">
      <p class="mt-2">You were invited to join "<b>{{showInvite.company_name}}</b>" by {{showInvite.created_by_first_name}} {{showInvite.created_by_last_name}}.
        {{ $t("common.welcome_screen.log_in_to_account_to_accept_invitation") }} </p>
    </div>
  </div>
</template>

<script>
  import { AuthStepsMixin } from '../mixins/AuthStepsMixin';
  import { signIn } from '../../../api/authApi';

  export default {
    name: 'LoginStep',
    mixins: [AuthStepsMixin],
    methods: {
      login: async function () {
        const payload = await signIn(this.personData.email, this.personData.password);
        if (payload) {
          this.$noty.success('You were successfully logged in ');

          await this.$store.dispatch('fetchAccount');

          if (!this.$store.state.account.first_name) {
            this.emitStep('accountSetup');
          } else if (this.$store.state.account.status === 'inactive' && !this.$store.state.account.email_confirmed) {
            this.emitStep('emailConfirmation');
          } else if (!this.$store.state.account.company_id) {
            this.emitStep('selectWorkspace');
          } else {
            window.location.href = '/calendar';
          }
        } else {
          this.$noty.error('It looks like password is not correct ');
        }
      },
    },
  };
</script>

<style scoped>

</style>
